export function checkIsUserLogin() {
    try {
        const token = localStorage.getItem("token");
        return token ? true : false;
    } catch (error) {
        return null;
    }
}
